<button class="dvlib-filter-option btn label label-radio label-default"
        (click)="toggleFilterOption.emit()"
        [class.active]="isToggled"
        type="button">
    {{ label }}

    <ng-content/>
</button>
